<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";

  .action-items {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    gap: utils.in_rem(8px);

    &.expanded {
      width: utils.in_rem(168px);
    }
  }
</style>

<script>
  import { userStore } from "@sourcewhale/shared/src/svelte/api-stores/user-store";
  import NavItem from "../NavItem.svelte";
  import { internalAdminStore } from "../stores/internal-admin-store";
  import { sidebarIsExpanded } from "../stores/sidebar-store.js";
  import ExploreButton from "./ExploreButton.svelte";
  import NotificationsDropdown from "./NotificationsDropdown.svelte";

  let adminActions = [];

  $: {
    const { depersonate, internalAdmin, showDepersonate, showInternalAdmin } =
      $internalAdminStore || {};

    adminActions = [
      showDepersonate && depersonate,
      showInternalAdmin && internalAdmin,
    ].filter(Boolean);
  }

  $: type = $sidebarIsExpanded ? "expanded" : "compressed";
</script>

<div class="action-items" class:expanded={$sidebarIsExpanded}>
  {#each adminActions as navItem}
    <NavItem {type} {navItem} />
  {/each}
  {#if $userStore.isPlgTrial}
    <ExploreButton />
  {:else}
    <NotificationsDropdown />
  {/if}
</div>
